import { createElement } from 'react';
import '../types/props.js';
import 'reakit/styled';
import 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import '../styled/space.js';
import '../styled/index.js';
import { c as _extends } from '../chunk-ad6ad343.js';
import 'polished';
import '../default/palette.js';
import 'reakit/Button';
import 'airbnb-prop-types';
import '../parseIcons.js';
import 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import '../Icon/styled.js';
import '../chunk-16546651.js';
import '../Set/styled.js';
import '../Set/index.js';
import '../Button/styled.js';
import '../Spinner/styled.js';
import '../Spinner/index.js';
import '../chunk-68945c57.js';
import 'lodash/omit';
import '../Button/ActionButtons.js';
import '../Button/index.js';
import Icon from '../Icon/index.js';
import VisuallyHidden from '../VisuallyHidden.js';
import 'reakit/Sidebar';
import { SidebarClose as SidebarClose$1 } from './styled.js';

var SidebarClose = function SidebarClose(props) {
  return createElement(SidebarClose$1, _extends({
    kind: "link"
  }, props), createElement(VisuallyHidden, null, "Close"), createElement(Icon, {
    a11yHidden: true,
    icon: "times"
  }));
};

SidebarClose.propTypes = {};
SidebarClose.defaultProps = {};
var C = SidebarClose;
export default C;
export { SidebarClose };